/**
 * sponsors actions.
 * @module actions/sponsors/sponsors
 */

import {
  CREATE_SPONSOR,
  DELETE_SPONSOR,
  GET_SPONSOR,
  LIST_SPONSORS,
  UPDATE_SPONSOR,
} from '../../constants/ActionTypes';

/**
 * Create sponsor function.
 * @function createSponsor
 * @param {Object|Array} content Sponsor data.
 * @returns {Object} Create sponsor action.
 */
export function createSponsor(content) {
  return {
    type: CREATE_SPONSOR,
    request: {
      op: 'post',
      path: '/@sponsors',
      data: content,
    },
  };
}

/**
 * Delete sponsor function.
 * @function deleteSponsor
 * @param {string} id Sponsor id
 * @returns {Object} Delete sponsor action.
 */
export function deleteSponsor(id) {
  return {
    type: DELETE_SPONSOR,
    request: {
      op: 'del',
      path: `/@sponsors/${id}`,
    },
  };
}

/**
 * Get sponsor function
 * @function getSponsor
 * @param {string} id Sponsor id
 * @returns {Object} Get sponsor action
 */
export function getSponsor(id) {
  return {
    type: GET_SPONSOR,
    request: {
      op: 'get',
      path: `/@sponsors/${id}`,
    },
  };
}

/**
 * List sponsors function
 * @function listSponsors
 * @returns {Object} List sponsors action
 */
export function listSponsors() {
  return {
    type: LIST_SPONSORS,
    request: {
      op: 'get',
      path: '/@sponsors',
    },
  };
}

/**
 * Update sponsor function
 * @function updateSponsor
 * @param {string} id Sponsor id
 * @param {Object} sponsor Sponsor data.
 * @returns {Object} Update sponsor action.
 */
export function updateSponsor(id, sponsor) {
  return {
    type: UPDATE_SPONSOR,
    request: { op: 'patch', path: `/@sponsors/${id}`, data: sponsor },
  };
}
